import React from 'react';
import { Tag } from 'antd';

export default function Status({ status = '' }) {
  const data = {
    color: 'blue',
    title: status.toUpperCase(),
  };

  if (status === 'accepted') {
    data.color = 'green';
  } else if (status === 'rejected') {
    data.color = 'volcano';
  }

  return (
    <Tag color={data.color}>{data.title}</Tag>
  );
}



// WEBPACK FOOTER //
// ./src/containers/ClaimBusiness/components/Status.js